import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc40f52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = { class: "content_nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav_reward" }, null, -1))
const _hoisted_6 = { class: "content_select" }
const _hoisted_7 = { class: "select_more" }
const _hoisted_8 = { class: "select_gift" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gift_size" }, "礼物尺寸:", -1))
const _hoisted_10 = { class: "gift_tip" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("建议上传图片尺寸200x200px,支持"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("JPEG，PNG，GIF,文件尺寸2M内。")
], -1))
const _hoisted_12 = { class: "select_frequency" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frequency_get" }, "发送频率:", -1))
const _hoisted_14 = { class: "gift_tip" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("设置每人发送礼物的间隔时间"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("为0时则为不限制。")
], -1))
const _hoisted_16 = { class: "cost_free" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "footer_to" }
const _hoisted_19 = { class: "footer_to_left" }
const _hoisted_20 = { class: "footer_img" }
const _hoisted_21 = { class: "content_box_right" }
const _hoisted_22 = { class: "right_title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "礼物名称：", -1))
const _hoisted_24 = { class: "input_area" }
const _hoisted_25 = { class: "text_number" }
const _hoisted_26 = { class: "right_price" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "礼物单价：", -1))
const _hoisted_28 = { class: "input_area" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "keep_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_c_loading = _resolveComponent("c-loading")!
  const _component_c_upload = _resolveComponent("c-upload")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_c_del_modal = _resolveComponent("c-del-modal")!
  const _component_GiftReward = _resolveComponent("GiftReward")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.createGift)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(" 互动打赏 "),
              _createVNode(_component_a_switch, {
                class: "btns_txt",
                checked: _ctx.matics,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.matics) = $event)),
                checkedValue: 1,
                unCheckedValue: 0,
                onChange: _ctx.updateOrInsertReward
              }, null, 8, ["checked", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", {
                class: "nav_record",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createGift = false))
              }, "礼物打赏记录 >>")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_a_input_number, {
                    class: "gift_input",
                    id: "inputNumber",
                    min: 0,
                    max: 100,
                    value: _ctx.imageSize,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imageSize) = $event))
                  }, null, 8, ["value"]),
                  _createTextVNode("px "),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_popover, { placement: "right" }, {
                      content: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_a_input_number, {
                    class: "gift_input",
                    id: "inputNumber",
                    min: 0,
                    max: 100,
                    value: _ctx.secLimitGift,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.secLimitGift) = $event))
                  }, null, 8, ["value"]),
                  _createTextVNode("秒 "),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_popover, { placement: "right" }, {
                      content: _withCtx(() => [
                        _hoisted_15
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionCircleFilled, { class: "QuestionCircleFilled" })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createVNode(_component_a_button, {
                  class: "button",
                  type: "primary",
                  onClick: _ctx.addOption
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加")
                  ]),
                  _: 1
                }, 8, ["onClick"]), [
                  [_vShow, _ctx.live.length < 8]
                ]),
                _createVNode(_component_a_button, {
                  class: "button",
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { onClick: _ctx.freeCharge }, {
                  default: _withCtx(() => [
                    _createTextVNode("一键免费")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            (_ctx.showLoading)
              ? (_openBlock(), _createBlock(_component_c_loading, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_draggable, _mergeProps({
                    handle: ".mover",
                    class: "content_box",
                    list: _ctx.live
                  }, _ctx.dragOptions, {
                    disabled: _ctx.live.length < 1,
                    onDrop: _ctx.dragDrop
                  }), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.live, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "content_box_left",
                          key: item.index
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_c_upload, {
                                  "file-list": _ctx.fileList,
                                  "handle-change": (info) => _ctx.handleChange(info, index),
                                  loading: item.loading,
                                  "image-name": item.image_url,
                                  "click-stop": (info) => _ctx.imageDel(info, index),
                                  class: "ant_upload"
                                }, null, 8, ["file-list", "handle-change", "loading", "image-name", "click-stop"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_a_input, {
                                    value: item.title,
                                    "onUpdate:value": ($event: any) => ((item.title) = $event),
                                    class: "area_tex",
                                    showCount: "",
                                    maxlength: 15,
                                    placeholder: "请输入礼物名称"
                                  }, {
                                    suffix: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(item.title.length) + "/15", 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "onUpdate:value"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_a_input, {
                                    value: item.amount,
                                    "onUpdate:value": ($event: any) => ((item.amount) = $event),
                                    class: "section_input"
                                  }, null, 8, ["value", "onUpdate:value"]),
                                  _createTextVNode("元")
                                ])
                              ])
                            ]),
                            _withDirectives(_createVNode(_component_svg_icon, {
                              class: "mover",
                              "icon-class": "drag_icon"
                            }, null, 512), [
                              [_vShow, _ctx.live.length > 1]
                            ]),
                            _createElementVNode("div", {
                              class: "frame_icon",
                              onClick: ($event: any) => (_ctx.closeClick(index))
                            }, [
                              _createVNode(_component_svg_icon, { "icon-class": "whiteList_del" })
                            ], 8, _hoisted_29)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 16, ["list", "disabled", "onDrop"]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_button, {
                      class: "button_tip",
                      type: "primary",
                      onClick: _ctx.updateOrInsertReward
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])),
            _createVNode(_component_c_del_modal, {
              visible: _ctx.deletes,
              centered: "",
              close: _ctx.openDelModal,
              ok: _ctx.close
            }, null, 8, ["visible", "close", "ok"])
          ]))
        : (_openBlock(), _createBlock(_component_GiftReward, {
            key: 1,
            onCreateStatus: _ctx.getCreateStatus
          }, null, 8, ["onCreateStatus"]))
    ])
  ], 64))
}